import { faCirclePause } from '@fortawesome/free-solid-svg-icons/faCirclePause';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons/faTriangleExclamation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CheckoutEnrollment, EnrollmentStatuses } from '@spike/membership-model';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import MembershipIcon from './MembershipIcon';
import styles from './SelectorMembershipItem.module.css';

interface SelectorMembershipItemProps {
    orderItemQuantity: number;
    enrollment: CheckoutEnrollment;
    className?: string;
    onClick?: () => void;
}

export const SelectorMembershipItem: FunctionComponent<SelectorMembershipItemProps> = props => {
    const outOfQuantity =
        props.enrollment.items.total !== 'unlimited' && props.orderItemQuantity > Number(props.enrollment.items.left);

    const alertIcon = (
        <FontAwesomeIcon
            icon={faTriangleExclamation}
            color="#EF4F57"
            fontSize={21}
            className={styles.icon}
        />
    );

    const pausedIcon = (
        <FontAwesomeIcon
            icon={faCirclePause}
            color="#000000"
            fontSize={21}
            className={styles.icon}
        />
    );

    const messageAlertIcon = (
        <FontAwesomeIcon
            icon={faTriangleExclamation}
            color="#EF4F57"
            fontSize={17}
            className={styles.icon}
        />
    );

    const messagePausedIcon = (
        <FontAwesomeIcon
            icon={faCirclePause}
            color="#000000"
            fontSize={17}
            className={styles.icon}
        />
    );

    const alertMessage = (
        <div className={styles.messageContainer}>
            {messageAlertIcon}
            <span className={styles.message}>This membership is pending payment and cannot be redeemed.</span>
        </div>
    );

    const pausedMessage = (
        <div className={styles.messageContainer}>
            {messagePausedIcon}
            <span className={styles.message}>This membership is paused and cannot be redeemed.</span>
        </div>
    );

    const outOfQuantityMessage = (
        <div className={styles.messageContainer}>
            {messageAlertIcon}
            <span className={styles.message}>
                This membership has insufficient uses remaining and cannot be applied.{' '}
            </span>
        </div>
    );

    const icon = [EnrollmentStatuses.pastDue, EnrollmentStatuses.pending].includes(props.enrollment.status)
        ? alertIcon
        : props.enrollment.status === EnrollmentStatuses.paused
        ? pausedIcon
        : outOfQuantity
        ? alertIcon
        : null;

    const message = [EnrollmentStatuses.pastDue, EnrollmentStatuses.pending].includes(props.enrollment.status)
        ? alertMessage
        : props.enrollment.status === EnrollmentStatuses.paused
        ? pausedMessage
        : outOfQuantity
        ? outOfQuantityMessage
        : null;

    const disabled = props.enrollment.status !== EnrollmentStatuses.active || outOfQuantity;

    return (
        <div
            className={clsx(styles.container, { [styles.disabledContainer]: disabled }, props.className)}
            onClick={disabled ? undefined : props.onClick}
        >
            <div className={styles.row}>
                <div className={clsx(styles.leftContainer, styles.ellipsis)}>
                    <span className={clsx(styles.text, styles.ellipsis, { [styles.disabledText]: disabled })}>
                        {props.enrollment.membership.name}
                    </span>
                </div>
                <div className={styles.rightContainer}>
                    {icon}
                    <div className={styles.counterContainer}>
                        <MembershipIcon className={styles.membershipIcon} />
                        <span className={clsx(styles.text, { [styles.disabledText]: disabled })}>
                            {props.enrollment.items.total === 'unlimited'
                                ? props.enrollment.items.total
                                : `${props.enrollment.items.left}/${props.enrollment.items.total}`}
                        </span>
                    </div>
                </div>
            </div>
            {message}
        </div>
    );
};

export default SelectorMembershipItem;
